import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {AppVersionDTO} from "../common/model/app-version-dto.model";
import {App} from "@capacitor/app";
import {map} from "rxjs/operators";
import {CommonService} from "./common.service";

@Injectable({
  providedIn: 'root'
})
export class AppVersionService {

  private _baseUrl = environment.host + "/utility/versions";

  _appVersion: string;
  currentActiveVersion: AppVersionDTO;

  constructor(private httpClient: HttpClient,
              private commonService: CommonService) {
  }

  get appVersion() {
    return this._appVersion;
  }

  public async checkIsActiveVersion(): Promise<boolean> {

    if (!this.commonService.isMobile()) {
      return true;
    }

    const appInfo = await App.getInfo();
    this._appVersion = appInfo.version;

    console.log("checkIsActiveVersion", appInfo, this.currentActiveVersion)
    return this.currentActiveVersion?.version?.includes(this._appVersion) === true;
  }

  public activeVersion(system: string): Observable<AppVersionDTO> {
    return this.httpClient.get<AppVersionDTO>(this._baseUrl + "/active", {
      params: {system}
    }).pipe(
      map((res) => {
        this.currentActiveVersion = res;
        console.log("currentActiveVersion", res);
        return res;
      })
    );
  }

}
